<script setup lang="ts">
import { useMmaLogout } from 'ui/graphql/web/hooks/mma/useMmaLogout';

import { login } from '../../config/pages';

const { onLogout, fetching: fetchingLogout, success: successLogout } = useMmaLogout(() => {
  window.location.href = login;
});

const route = useRoute();
const router = useRouter();
const routeUuid = computed(() => route.params.uuid as string);
const {
  loading,
  error,
  uuid,
} = useEntityOrUndefined();
watch(routeUuid, (entityUuid) => {
  if (entityUuid) {
    uuid.value = entityUuid;
  }
}, { immediate: true });
const onChangeUuid = (entityUuid: string) => {
  switch (route.name) {
    case 'settings':
      router.push('/settings');
      break;
    case 'renters-billing':
      router.push('/renters/billing');
      break;
    case 'renters-billing-history':
      router.push('/renters/billing/history');
      break;
    case 'tuition-billing':
      router.push('/tuition/billing');
      break;
    case 'tuition-billing-history':
      router.push('/tuition/billing/history');
      break;
    case 'uuid-info':
      router.push(`/${entityUuid}/info`);
      break;
    default:
      router.push(`/${entityUuid}`);
  }
  uuid.value = entityUuid;
};
</script>
<template>
  <LayoutLoading v-if="loading">
    Loading insured <UiFaIcon :icon="['fas', 'spinner-scale']" :spin="true" />
  </LayoutLoading>
  <div v-else-if="error" class="flex flex-col gap-10 justify-center items-center h-screen">
    <UiSvg404 />
    <UiTitleH1>
      Page not found
    </UiTitleH1>
  </div>
  <template v-else>
    <LayoutLoading v-if="fetchingLogout || successLogout">
      Logging out <UiFaIcon :icon="['fas', 'spinner-scale']" :spin="true" />
    </LayoutLoading>
    <LayoutLogged
      :uuid="uuid"
      :on-logout="onLogout"
      :fetching-logout="fetchingLogout"
      @update:uuid="onChangeUuid"
    >
      <template #content>
        <slot name="content" />
      </template>
    </LayoutLogged>
  </template>
</template>
